import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

export const MessagePageGuard: CanActivateFn =
    (
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ) =>
    {
        // Inject the router into the function
        let router = inject(Router);

        // Get the current location and the next except for any query params
        let currentLocation = router.url.split('?').shift();
        let nextLocation = state.url.split('?').shift();

        // Check that the current location is not a message page too,
        // and if not then navigate
        return currentLocation !== nextLocation && nextLocation !== 'azureb2c-create-account-entry';
    }